import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {resources} from '../data/programs';

const {FiExternalLink, FiShield, FiInfo} = FiIcons;

const locationLinks = [
  {name: 'Dallas', url: 'https://hvacschoolsdallas.com'},
  {name: 'Houston', url: 'https://hvacclasseshouston.com'},
  {name: 'San Antonio', url: 'https://hvacclassessanantonio.com'},
  {name: 'Phoenix', url: 'https://hvacschoolsphoenix.com'},
  {name: 'Las Vegas', url: 'https://hvacschoolslasvegas.com'},
  {name: 'New York', url: 'https://hvacschoolsnyc.com'},
  {name: 'New Jersey', url: 'https://hvacschoolsnj.com'},
  {name: 'Chicago', url: 'https://hvacschoolschicago.com'},
  {name: 'Connecticut', url: 'https://cthvacschools.com'},
];

function Resources() {
  return (
    <footer className="resources">
      <div className="section">
        <div className="section-heading align-left">
          <p className="eyebrow">Trusted references</p>
          <h2>Explore Florida HVAC Career Resources</h2>
          <p>Use authoritative sources to understand certification, licensing, energy efficiency, employment outlook, and modern HVAC technician responsibilities in Florida.</p>
          <p>Before enrolling, compare official program information with your goals. Ask about EPA Section 608 preparation, electrical troubleshooting, refrigeration, gas heating, heat pumps, controls, airflow measurement, and hands-on practice.</p>
        </div>
        <div className="resource-list">
          {resources.map((resource) => (
            <a href={resource.url} target="_blank" rel="noreferrer" key={resource.title}>
              <span className="resource-icon"><SafeIcon icon={FiExternalLink} /></span>
              <span><strong>{resource.title}</strong><small>{resource.description}</small></span>
            </a>
          ))}
        </div>
        <div className="disclaimer">
          <SafeIcon icon={FiInfo} />
          <p>This independent directory is for educational research. It is not a school and does not guarantee admission, employment, licensing, certification, or wages. Verify program details directly with each school and the relevant Florida and federal agencies.</p>
        </div>
        <div className="footer-bottom">
          <span className="footer-brand"><SafeIcon icon={FiShield} /><a href="/" aria-label="HVAC Schools Florida home page">HVAC Schools Florida</a></span>
          <div className="footer-links"><span aria-hidden="true">·</span><a href="/privacy-policy">Privacy Policy</a><span aria-hidden="true">·</span><a href="/sitemap.xml">Sitemap</a><span>© 2026 All rights reserved.</span></div>
        </div>
        <nav className="location-navigation" aria-label="HVAC schools by location">
          <span>View HVAC schools in other locations: </span>
          {locationLinks.map((location, index) => <span key={location.name}><a href={location.url} target="_blank" rel="noreferrer">{location.name}</a>{index < locationLinks.length - 1 ? ', ' : ''}</span>)}
        </nav>
      </div>
    </footer>
  );
}

export default Resources;